'use client';

import { BreadcrumbsInline } from './components/BreadcrumbsInline';
import { BreadcrumbsPageHeader } from './components/BreadcrumbsPageHeader';
import { BreadcrumbsSkeleton } from './components/BreadcrumbsSkeleton';
import type { BreadcrumbsProps } from './components/Breadcrumbs.shared';

export type {
  BreadcrumbItem,
  BreadcrumbsInlineProps,
  BreadcrumbsPageHeaderProps,
  BreadcrumbsProps,
  BreadcrumbsSkeletonProps,
} from './components/Breadcrumbs.shared';
export { ChevronSeparator, formatLabel } from './components/Breadcrumbs.shared';
export { BreadcrumbsSkeleton } from './components/BreadcrumbsSkeleton';

/**
 * Breadcrumbs component with three visual variants:
 * - `inline` (default): compact trail with chevron separators for PLPs/PDPs
 * - `pageHeader`: large page title with an optional breadcrumb trail for checkout and service flows
 * - `skeleton`: loading placeholder for Suspense boundaries
 */
export const Breadcrumbs = (props: BreadcrumbsProps) => {
  if (props.variant === 'pageHeader') {
    return <BreadcrumbsPageHeader {...props} />;
  }

  if (props.variant === 'skeleton') {
    return <BreadcrumbsSkeleton className={props.className} testId={props.testId} />;
  }

  if (!('items' in props) || !props.items) {
    return null;
  }

  return <BreadcrumbsInline {...props} />;
};

Breadcrumbs.displayName = 'Breadcrumbs';
